/**
 * Resolves stored media paths to absolute URLs.
 *
 * Paths from the database look like: /uploads/images/uuid.jpg
 * These are relative to the backend (api.domain.com).
 * External URLs (Unsplash, Giphy, data:) pass through unchanged.
 */

export const API_URL = process.env.REACT_APP_API_URL || '';

export function resolveMediaUrl(src) {
  if (!src) return '';
  if (
    src.startsWith('http://') ||
    src.startsWith('https://') ||
    src.startsWith('data:') ||
    src.startsWith('//')
  ) {
    return src;
  }
  // Relative path — prepend the backend origin
  return `${API_URL}${src}`;
}
